class HHVideoIntersect extends HTMLElement {
  constructor() {
    super()

    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
    this.observerConfig = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) =>
        entry.isIntersecting ? this.video.play() : this.video.pause()
      )
    }, this.observerConfig)
  }

  get video() {
    return this.querySelector('video')
  }

  connectedCallback() {
    this.reduceMotion
      ? this.video.setAttribute('controls', true)
      : this.observer.observe(this.video)

    this.video.addEventListener('timeupdate', this.handleTimeUpdate)
    this.videoTrigger.addEventListener('click', this.toggleVideo)
  }

  handleTimeUpdate = () => {
    if (this.video.currentTime > 0) {
      this.videoTrigger.classList.add('hidden')
    }
  }

  toggleVideo = () => {
    if (this.videoTrigger.classList.contains('playing')) {
      this.videoTrigger.classList.remove('playing')
      this.video.pause()
    } else {
      this.videoTrigger.classList.add('playing')
      this.video.play()
    }
  }

  get videoTrigger() {
    return this.querySelector('.js-poster-trigger')
  }
}

customElements.define('hh-video-intersect', HHVideoIntersect)
